import { InjectionToken } from '@angular/core';

/** TTL for dashboard preferences in minutes */
export const DASHBOARD_PREFERENCES_TTL = new InjectionToken<number>('DashboardPreferencesTTL');
